import { createClient } from '@supabase/supabase-js'

/**
 * Cliente de Supabase para la interacción con la base de datos y servicios de autenticación.
 * * Se inicializa utilizando las variables de entorno:
 * - `VITE_SUPABASE_URL`: La URL del proyecto de Supabase.
 * - `VITE_PUBLISHABLE_KEY`: La clave pública (anon key) para el acceso del cliente.
 * * @constant
 * @type {import('@supabase/supabase-js').SupabaseClient}
 */
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_PUBLISHABLE_KEY
)
